<template>
  <div class="nlr__bg" v-if="nextLvlRequirementsOpen" @click="closeNextLvlRequirements">
    <div class="nlr__popup" @click.stop>
      <div class="nlr__popup__top free">
        <div class="nlr__digit free"><span>{{ nextFriendsLevel.num }}</span></div>
        <div class="nlr__text">
          <div class="nlr__text__heading">{{ nextFriendsLevel.title }}</div>
          <div class="nlr__text__subheading">{{ $t("pop_ups.next_lvl_requirements.achieve_start") }} {{ nextFriendsLevel.num }}{{ $t("pop_ups.next_lvl_requirements.achieve_end") }}</div>
          <ul class="nlr__text__checkpoint__list">
            <!-- <li class="nlr__text__checkpoint fulfilled"><span class="nlr__text__checkpoint_text">Заполненная анкета</span></li> -->
            <li class="nlr__text__checkpoint" v-for="(req, index) in nextFriendsLevel.requirements" :key="index"><span class="nlr__text__checkpoint_text">{{ req }}</span></li>
            <!-- <li class="nlr__text__checkpoint"><span class="nlr__text__checkpoint_text">2 бейджа</span></li> -->
          </ul>
        </div>
        <div class="nlr__progress">
          <div class="nlr__progress__top">
            <p class="nlr__progress__currentlvl">{{ currentLevel.name }}</p>
            <p class="nlr__progress__points"><span>{{ levelPointsEarned }}</span> / {{ levelPointsCap }} {{ $t("pop_ups.next_lvl_requirements.points") }}</p>
          </div>
          <div class="nlr__progress__bar">
            <div class="nlr__progress__bar__inner free" :style="{'width': progressPerc + '%'}"></div>
          </div>
        </div>
      </div>
      <div class="nlr__popup__bottom">
        <p class="nlr__link__container">
          <span class="nlr__link" @click="onLinkClicked">{{ $t("pop_ups.next_lvl_requirements.program_dets") }}</span>
        </p>
        <div class="nlr__close free" @click="closeNextLvlRequirements">{{ $t("pop_ups.next_lvl_requirements.close") }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Store from '../../store'
export default {
  computed: {
    dicts: function () {
      return Store.getters.dicts()
    },
    friendsLevels: function () {
      return Store.getters.friendsLevels()
    },
    friendsLevelsByDictId: function () {
      return Store.getters.friendsLevelsByDictId()
    },
    nextLvlRequirementsOpen: function () {
      return Store.state.nextLvlRequirementsOpen
    },
    user: function () {
      return Store.state.user
    },
    currentLevel: function () {
      return this.dicts.levelsById[this.user.balance.loyalty_level] || this.dicts.levelsById[3] // КОСТЫЛЬ до первой покупки.
    },
    nextLevel: function () {
      return this.dicts.levelsById[this.currentLevel.next_level_id]
    },
    nextFriendsLevel: function () {
      return this.friendsLevelsByDictId[this.currentLevel.next_level_id]
    },
    levelPointsCap: function () {
      return this.currentLevel.max_point - this.currentLevel.min_point > 0 ? this.currentLevel.max_point - this.currentLevel.min_point : 1
    },
    levelPointsEarned: function () {
      return this.user.balance.lifetime_points - this.currentLevel.min_point
    },
    progressPerc: function () {
      return parseInt(this.levelPointsEarned / this.levelPointsCap * 100)
    }
  },
  methods: {
    closeNextLvlRequirements: function () {
      Store.commit('closeNextLvlRequirements')
    },
    onLinkClicked: function () {
      this.$router.push('friends')
      this.closeNextLvlRequirements()
    }
  }
}
</script>




// WEBPACK FOOTER //
// next-lvl-reqirements.vue?c5a8bca2